/*
|--------------------------------------------------------------------------
| Utilities: Takeover
|--------------------------------------------------------------------------
*/

/**
 * Takeover
 * Replace a dom with content from the takeover json feed
 * @namespace
 */
__gh__webApp.utilities.takeover = {
	
	/**
	 * Initilize takeover utility
	 */
	 "init": function(){
		 var thisObject = __gh__webApp.utilities.takeover;
		 thisObject.loadAllTakeOvers();
	 },
	 
	 
	/**
	 * Remove the loading class from the takeover dom
	 */
	"removeLoadingGif": function(dom){
		$(dom).removeClass("loading");
	},
	
	
	/**
	 * It will attempt to look for views.takeover.[takeover].getSubView to load any subViews or modify the takeover before its layed down.
	 * @param {object} takeover - takeover object
	 */
	"getSubView": function(takeover){
		var views 		= __gh__webApp.views.takeover,
			viewName 	= takeover.view.name;
		if(viewName in views && "getSubView" in views[viewName]){
			return views[viewName].getSubView(takeover);
		}
		//Set default view path
		takeover.view.name 	= "takeovers/"+viewName+"/default";
		return takeover;
	},
	
	
	/**
	 * Check to see if there is an article
	 */
	"hasItems": function(jsonData){
		var commonJS 	= __gh__webApp.common;
		return !(!jsonData || commonJS.isObjectEmpty(jsonData) || (("main" in jsonData) &&  ("success" in jsonData.main[0]) && jsonData.main[0].success == false));
	},
	
	
	/**
	 * Initial callback that has the feedURL for an article and whether or not it's live or preview mode
	  * @param {object} data - data object passed from the load all takeovers call
	 */
	 "takeOverCallback1": function(data){
		var thisObject		= __gh__webApp.utilities.takeover,
			fetchJSON 		= __gh__webApp.utilities.fetch.json.get,
			jsonData 		= ("json" in data) ? data.json : {},
			hasItems		= thisObject.hasItems(jsonData),
			firstItem 		= (hasItems) ? jsonData.main[0] : {},
			takeoverPreview	= (hasItems && "takeoverPreview" in firstItem) ? firstItem.takeoverPreview : null,
			showTakeover	= (takeoverPreview != 'live' || !takeoverPreview) ? false : true,
			feedURL			= ("feedURL" in firstItem) ? firstItem.feedURL : null;

		if (!showTakeover) {
			thisObject.removeLoadingGif(data.dom);
			return; 
		}

		delete data.json;
		var callbacks		= [{
				"callback": "__gh__webApp.utilities.takeover.takeOverCallback2",
				"data": data
			}];
			
		fetchJSON({
			"async"			: true,
			"url"			: feedURL,
			"callbacks"		: callbacks,
			"errorCallbacks": callbacks
		});
	},
	
	
	/**
	 * Secondary callback that contains the article feed that we can check and laydown the takeover view
	 * @param {object} data - data object passed from the first callback
	 */
	"takeOverCallback2": function(data){
		var thisObject			= __gh__webApp.utilities.takeover,
			injectView			= __gh__webApp.utilities.fetch.handlebarsView.replace,
			jsonData 			= ("json" in data) ? data.json : {},
			takeover			= ("takeover" in data) ? data.takeover : {},
			dom					= ("dom" in data) ? data.dom : {},
			takeoverHasItems;
		
		takeover.items 		= jsonData;
		takeoverHasItems	= thisObject.hasItems(jsonData);
		takeover 			= (takeoverHasItems) ? thisObject.getSubView(takeover) : false;

		if(!takeover){ 
			thisObject.removeLoadingGif(dom);
			return; 
		}
		
		$(dom).addClass("takeover");
		
		injectView({
			"dom":	dom,
			"view": takeover.view.name,
			"data": takeover
		});
		
		thisObject.removeLoadingGif(dom);
		
		thisObject.triggerPostLaydownFunctions(takeover);
	},
	
	
	/**
	 * Load all takeovers on a page
	 */
	"loadAllTakeOvers": function() {
		var fetchJSON 	= __gh__webApp.utilities.fetch.json.get,
			$takeovers	= $("[data-gh-takeover-loaded=false]");
		
		if (!$takeovers.length){ return; }

		$takeovers.each(function(){
			var $this  		= $(this),
				takeover	= $this.data("gh-takeover-object"),
				callbackData	= {
					"dom":	this,
					"takeover": takeover
				},
				callbacks		= [{
					"callback": "__gh__webApp.utilities.takeover.takeOverCallback1",
					"data": callbackData
				}];
			
			
			if (!takeover) { 
				thisObject.removeLoadingGif(this);
				return; 
			}
			
			fetchJSON({
				"async"	: true,
				"url": takeover.feedURL,
				"callbacks": callbacks,
				"errorCallbacks": callbacks
			});
			
			$this.attr("data-gh-takeover-loaded",true);
	  	});
	},
	
	
	/**
	 * Callback functions that are called after a takeover is layed down.
	 * It will attempt to look for views.takeover.[takeover].callbacks to load any call back functions for a view
	 * @param {object} takeover - takeover object
	 */
	"triggerPostLaydownFunctions": function(takeover){
		var thisObject		= __gh__webApp.utilities.takeover,
			views 			= __gh__webApp.views.takeover,
			viewStaticName 	= takeover.view.staticName,
			utilities		= __gh__webApp.utilities;
		
		if(views[viewStaticName] && views[viewStaticName].callbacks){
			views[viewStaticName].callbacks(takeover);
		}

		// Global Post laydown functions go here
		utilities.lazyImages.loadAllImages();

	},

		
};